import { parse as parser } from '@news12/transformer'

import React from 'react'

import resolveImageDomain from '../../data/transformers/resolveImageDomain'
import useDynamicScripts from '../../hooks/useDynamicScripts'
import { structure } from '../../styles/global'
import BaseCSS from '../../styles/global/BaseCSS'
import style from '../../styles/pages/projects'
import Metadata from '../Metadata'
import UnresetCSS from '../UnresetCSS'
import renderHtml, { sanitizedHtml } from '../utilities/renderHTML'
import Credits from './Credits'

import Head from 'next/head'

const Project = ({ data }) => {
  const { description, thumbnail, title, css, credits, body } = data?.[0]?.fields
  const html = parser(body, false)
  useDynamicScripts({ html, scripts: ['facebook-embed', 'tagboard-embed', 'twitter-embed'] })

  const metatagProps = {
    title,
    description,
    thumbnails: {
      large: `https:${resolveImageDomain(thumbnail?.fields?.file?.url)}?fm=webp`
    }
  }

  return (
    <>
      <Head>
        <title>{data?.[0]?.fields?.title || 'News 12'}</title>
      </Head>
      <Metadata slugable={metatagProps} />
      <div className='projects-container'>
        {renderHtml(sanitizedHtml(html))}
        {credits && <Credits credits={credits} />}
        <style jsx global>
          {structure}
        </style>
        <UnresetCSS />
        <BaseCSS />
      </div>
      {css ? <style jsx>{css}</style> : <style jsx>{style}</style>}
    </>
  )
}

export default Project
